
export const FlowSteps = {
  PROFILE_SELECTED: 'profile',
  BRANCH_SELECTED: 'branch',
  LOGGED_IN: 'login'
};
